import { orchestrator } from 'satcheljs';
import { deleteEvent, closeComposeForm } from 'owa-calendar-compose-form-actions';
import { lazyDeleteCalendarEventWithConfirm } from 'owa-calendar-event-actions-with-confirm';
import { isSeriesMaster } from 'owa-calendar-event-capabilities';

export default orchestrator(deleteEvent, actionMessage => {
    const { eventScope, isInPopOutWindow, event } = actionMessage;
    lazyDeleteCalendarEventWithConfirm.importAndExecute(
        event,
        eventScope,
        isSeriesMaster(event),
        'EditForm',
        isInPopOutWindow,
        null /*onCancel */,
        () => {
            closeComposeForm(false /* shouldResetStore */, event.IsMeeting);
        }
    );
});
